/**
 * Checks whether the user is currently logged in.
 *
 * - Returns `true` if a "token" exists in localStorage (browser only).
 * - Returns `false` if no token is found or the code runs on the server.
 */

export const checkIsLoggedIn = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }
  return !!localStorage.getItem("token");
};
